<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>


<script>
import "vant/lib/index.css";

export default {
  name: "App",
};
</script>

<style>

html, body {
  height: 100%;
  overflow: hidden;
  overflow-y: auto;
  background-color: #fff;
  margin: 0;
  padding: 0;
  width: 100%;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 100%;
  color: #2c3e50;
  font-size: 14px;
  height: 100%;
  margin: 0;
  padding: 0;
}
</style>
